/* Display-only currency switcher: converts visible prices for reference; checkout stays in the store currency. */
(function () {
  var cfg = window.DisplayCurrency;
  if (!cfg || window.__displayCurrencyInit) return;
  window.__displayCurrencyInit = true;

  var KEY = 'dc_currency';
  var ALLOWED = ['HKD', 'MOP', 'JPY', 'TWD', 'USD'];
  var SYMBOLS = { HKD: 'HK$', MOP: 'MOP$', JPY: '¥', TWD: 'NT$', USD: 'US$' };
  var DECIMALS = { HKD: 0, MOP: 0, JPY: 0, TWD: 0, USD: 2 };
  var base = cfg.base;
  var rates = null;

  var COUNTRY_CURRENCY = { HK: 'HKD', MO: 'MOP', JP: 'JPY', TW: 'TWD' };
  var DETECT_KEY = 'dc_detected';
  var detected = null;

  function stored() {
    try {
      var v = localStorage.getItem(KEY);
      if (ALLOWED.indexOf(v) > -1) return v;
    } catch (e) {}
    return null;
  }
  // A currency the visitor picked wins; otherwise use the one matching their IP location.
  function current() {
    return stored() || detected || (ALLOWED.indexOf(cfg.defaultCurrency) > -1 ? cfg.defaultCurrency : base);
  }
  function detect(done) {
    if (stored()) return done();
    try {
      var cached = sessionStorage.getItem(DETECT_KEY);
      if (ALLOWED.indexOf(cached) > -1) { detected = cached; return done(); }
    } catch (e) {}
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        var iso = c && (c.handle || c.code);
        if (!iso) return;
        detected = COUNTRY_CURRENCY[String(iso).toUpperCase()] || 'USD';
        try { sessionStorage.setItem(DETECT_KEY, detected); } catch (e) {}
      })
      .catch(function () {})
      .then(done);
  }
  function store(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }

  // Derive the money pattern from a sample rendered by the `money` filter (123456 cents).
  var sample = String(cfg.sample || '').trim();
  var m = sample.match(/^(.*?)1([,.'\s]?)234(?:([.,])56)?(.*)$/);
  if (!m) return;
  var prefix = m[1].trim(), thou = m[2] || ',', dec = m[3] || '.', suffix = m[4].trim();
  if (!prefix && !suffix) return;
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var num = '(\\d{1,3}(?:' + esc(thou) + '\\d{3})+(?:' + esc(dec) + '\\d{1,2})?|\\d+(?:' + esc(dec) + '\\d{1,2})?)';
  // Swallow a currency code written before a bare symbol (e.g. "HK$1,000" when the money format is "$"), so no stray "HK" is left behind.
  var lead = /^[^A-Za-z]/.test(prefix) ? '(?:HK|MOP|US|NT)?' : '';
  var pattern = new RegExp((prefix ? lead + esc(prefix) + '\\s?' : '') + num + (suffix ? '\\s?' + esc(suffix) : ''), 'g');

  function parse(s) {
    return parseFloat(s.split(thou).join('').replace(dec, '.'));
  }
  function format(amount, code) {
    var d = DECIMALS[code];
    var n = new Intl.NumberFormat('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }).format(amount);
    return '≈ ' + SYMBOLS[code] + n;
  }
  function convert(amount, to) {
    if (!rates || !rates[base] || !rates[to]) return null;
    return amount * rates[base] / rates[to];
  }

  var originals = new WeakMap();
  var written = new WeakMap();
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  function processText(node, code) {
    var text = node.nodeValue;
    var original = written.get(node) === text ? originals.get(node) : text;
    originals.set(node, original);
    var out = original;
    if (code !== base && rates) {
      pattern.lastIndex = 0;
      if (pattern.test(original)) {
        pattern.lastIndex = 0;
        out = original.replace(pattern, function (all, n) {
          var v = convert(parse(n), code);
          return v === null ? all : format(v, code);
        });
      }
    }
    if (node.nodeValue !== out) node.nodeValue = out;
    written.set(node, out);
  }

  function scan(root, code) {
    if (!root) return;
    if (root.nodeType === 3) { processText(root, code); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName] || (root.closest && root.closest('[data-dc-ignore]'))) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || p.closest('[data-dc-ignore]')) return NodeFilter.FILTER_REJECT;
        return /\d/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var n;
    while ((n = walker.nextNode())) processText(n, code);
  }

  function updateNotes(code) {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      var note = btn.parentNode.querySelector('.dc-checkout-note');
      if (code === base) {
        if (note) note.remove();
        return;
      }
      if (!note) {
        note = document.createElement('p');
        note.className = 'dc-checkout-note';
        note.setAttribute('data-dc-ignore', '');
        note.textContent = cfg.note;
        btn.insertAdjacentElement('afterend', note);
      }
    });
  }

  function updateSelectors(code) {
    document.querySelectorAll('[data-dc-current]').forEach(function (el) {
      el.textContent = code + ' ' + SYMBOLS[code];
    });
    document.querySelectorAll('[data-dc-option]').forEach(function (btn) {
      var on = btn.getAttribute('data-dc-option') === code;
      btn.parentNode.classList.toggle('regular-select-item--selected', on);
      if (on) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  var observer = new MutationObserver(function (mutations) {
    observer.disconnect();
    var code = current();
    mutations.forEach(function (mu) {
      if (mu.type === 'characterData') scan(mu.target, code);
      else mu.addedNodes.forEach(function (n) { scan(n, code); });
    });
    updateNotes(code);
    observe();
  });
  function observe() {
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  function apply() {
    var code = current();
    observer.disconnect();
    updateSelectors(code);
    scan(document.body, code);
    updateNotes(code);
    observe();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-option]');
    if (!btn) return;
    e.preventDefault();
    store(btn.getAttribute('data-dc-option'));
    apply();
  });

  function loadRates() {
    if (window.Currency && window.Currency.rates) {
      rates = window.Currency.rates;
      apply();
      return;
    }
    var s = document.createElement('script');
    s.src = cfg.ratesUrl;
    s.onload = function () {
      if (window.Currency && window.Currency.rates) rates = window.Currency.rates;
      apply();
    };
    s.onerror = apply;
    document.head.appendChild(s);
  }

  function start() { detect(loadRates); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
